import React from 'react'
import { useFetchSubmissionPdfQuery } from '../../../../../store/apis/submission.api'
import PdfViewer from '../../../../../components/common/PdfViewer/PdfViewer'

const SubmissionPdfView = ({ submissionId }) => {
    const { data, isLoading, error } = useFetchSubmissionPdfQuery({ submissionId })

    const handlePdfLoadError = error => console.error('SubmissionPdfView: PDF Load Error from PdfViewer:', error)

    return (
        <PdfViewer file={data} isLoading={isLoading} error={error} onError={handlePdfLoadError}/>
    )
}

export default SubmissionPdfView 